import React from 'react';
import { Icon, Text, Tooltip } from '@zillow/constellation-10';
import { IconQuestionMarkCircleOutline } from '@zillow/constellation-icons';
import {
  AdproductsUserBillingInvoiceApiHandler_getErrorMessageForPayment,
  type AdproductsZuoraInvoicePaymentDto,
} from '@zg-rentals/ts-adproducts-client';

export const InvoicePaymentDisplay = ({ value }: { value: AdproductsZuoraInvoicePaymentDto }) => {
  const { displayStatus } = value;
  const [metroidErrorMessage, setMetroidErrorMessage] = React.useState('');

  React.useEffect(() => {
    if (displayStatus === 'Error') {
      AdproductsUserBillingInvoiceApiHandler_getErrorMessageForPayment({
        accountId: value.accountId,
        paymentId: value.id,
        invoiceId: value.invoiceId,
      })
        .then(setMetroidErrorMessage)
        .catch(() => setMetroidErrorMessage(''));
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, []);

  if (!displayStatus) {
    return <>-</>;
  }

  return (
    <>
      {metroidErrorMessage ? (
        <Tooltip
          content={metroidErrorMessage}
          trigger={
            <Text css={{ display: 'flex', alignItems: 'center', width: 'min-content', marginInline: 'auto' }}>
              {displayStatus}
              {/* oxlint-disable-next-line constellation/prefer-semantic-tokens -- pre-existing base-token usage; was warn-only under ESLint's pandaLint */}
              <Icon size="sm" css={{ position: 'relative', bottom: '3px', color: 'gray.400' }}>
                <IconQuestionMarkCircleOutline />
              </Icon>
            </Text>
          }
        />
      ) : (
        <Text>{displayStatus}</Text>
      )}
    </>
  );
};
